import { defineComponent as _defineComponent } from 'vue'
import BasicButton from '@/ui-components/BasicButton.vue';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';


export default /*#__PURE__*/_defineComponent({
  __name: 'LabeledButton',
  props: {
    icon: null,
    highlight: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,BasicButton }
}

})